import { getIsUSMarket } from 'modules/company/redux/selectors';
import { type AppState } from 'src/core/reducers';

export const getI18nContext = (state: AppState) =>
  getIsUSMarket(state) ? { context: 'US' } : undefined;
